import { render, staticRenderFns } from "./occupationSituation.vue?vue&type=template&id=16b2d7c3&scoped=true"
import script from "./occupationSituation.vue?vue&type=script&lang=js"
export * from "./occupationSituation.vue?vue&type=script&lang=js"
import style0 from "./occupationSituation.vue?vue&type=style&index=0&id=16b2d7c3&lang=scss"
import style1 from "./occupationSituation.vue?vue&type=style&index=1&id=16b2d7c3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b2d7c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b2d7c3')) {
      api.createRecord('16b2d7c3', component.options)
    } else {
      api.reload('16b2d7c3', component.options)
    }
    module.hot.accept("./occupationSituation.vue?vue&type=template&id=16b2d7c3&scoped=true", function () {
      api.rerender('16b2d7c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/marketplane/components/occupationSituation.vue"
export default component.exports